import * as fromActions from '../actions';
import * as fromModels from '../../models';

export interface DistributionDetailsState {
  loadingCharges: boolean;
  loadedCharges: boolean;
  updated: boolean;
  updating: boolean;
  errors: any[];
  shippingCharges: fromModels.ShippingCharge[];
}

export const initialState: DistributionDetailsState = {
  loadingCharges: false,
  loadedCharges: false,
  updating: false,
  updated: true,
  errors: null,
  shippingCharges: null
};

export function reducer(state = initialState, action: fromActions.DistributionActions): DistributionDetailsState {
  switch (action.type) {
    case fromActions.DistributionActionTypes.LoadShippingCharges: {
      return {
        ...state,
        loadingCharges: true,
        loadedCharges: false,
        shippingCharges: null
      };
    }

    case fromActions.DistributionActionTypes.LoadShippingChargesSuccess: {
      return {
        ...state,
        loadingCharges: false,
        loadedCharges: true,
        errors: null,
        shippingCharges: [...action.payload]
      };
    }

    case fromActions.DistributionActionTypes.LoadShippingChargesFailure: {
      return {
        ...state,
        loadingCharges: false,
        loadedCharges: false,
        errors: action.payload,
        shippingCharges: null
      };
    }

    case fromActions.DistributionActionTypes.UpdateShippingCharges: {
      return {
        ...state,
        updating: true,
        updated: false
      };
    }

    case fromActions.DistributionActionTypes.UpdateShippingChargesFailure: {
      return {
        ...state,
        updating: false,
        updated: false,
        errors: action.payload
      };
    }

    case fromActions.DistributionActionTypes.UpdateShippingChargesSuccess: {
      const shippingCharges = state.shippingCharges.map((sc: fromModels.ShippingCharge) => {
        const changed = action.payload.changed.find((c: fromModels.ShippingCharge) => c.rentalCategoryCode === sc.rentalCategoryCode && c.state === sc.state);
        if (changed) {
          return changed;
        } else {
          return sc;
        }
      });
      return {
        ...state,
        updating: false,
        updated: true,
        errors: null,
        shippingCharges
      };
    }

    default: {
      if (Object.values(fromActions.DistributionActionTypes).includes((action as fromActions.DistributionActions).type)) {
        console.log('distribution.reducer: unhandled action: ', action);
      }
    }
  }

  return state;
}
